/* eslint-disable @typescript-eslint/naming-convention */
import {
  addLanguageData,
  getBrowserLocale,
  getSupportedLanguages,
  initLocalization,
  LanguageKey,
  setLanguage,
} from '@softgames/localization';

import type { AppStateController } from '../state/AppStateController';

import en_US from '../../../configs/localizations/en_US.json';
import fr_FR from '../../../configs/localizations/fr_FR.json';
import it_IT from '../../../configs/localizations/it_IT.json';
import de_DE from '../../../configs/localizations/de_DE.json';
import es_ES from '../../../configs/localizations/es_ES.json';
import ja_JP from '../../../configs/localizations/ja_JP.json';
import ko_KR from '../../../configs/localizations/ko_KR.json';
import nl_NL from '../../../configs/localizations/nl_NL.json';
import pl_PL from '../../../configs/localizations/pl_PL.json';
import pt_PT from '../../../configs/localizations/pt_PT.json';

const defaultSupportedLanguages: LanguageKey[] = [
  LanguageKey.ENGLISH_US,
  LanguageKey.FRENCH_FR,
  LanguageKey.ITALIAN_IT,
  LanguageKey.GERMAN_DE,
  LanguageKey.SPANISH_ES,
  LanguageKey.POLISH_PL,
  LanguageKey.DUTCH_NL,
  LanguageKey.PORTUGUESE_PT,
  LanguageKey.JAPANESE_JP,
  LanguageKey.KOREAN_KO,
];

export function initializeLocalization(state: AppStateController, supportedLanguages?: LanguageKey[]): void {
  supportedLanguages = supportedLanguages ?? defaultSupportedLanguages;

  initLocalization({ supportedLanguages });

  addLanguageData({
    [LanguageKey.ENGLISH_US]: en_US,
    [LanguageKey.FRENCH_FR]: fr_FR,
    [LanguageKey.ITALIAN_IT]: it_IT,
    [LanguageKey.GERMAN_DE]: de_DE,
    [LanguageKey.SPANISH_ES]: es_ES,
    [LanguageKey.POLISH_PL]: pl_PL,
    [LanguageKey.DUTCH_NL]: nl_NL,
    [LanguageKey.PORTUGUESE_PT]: pt_PT,
    [LanguageKey.JAPANESE_JP]: ja_JP,
    [LanguageKey.KOREAN_KO]: ko_KR,
  });

  const savedLanguage = state.getLanguage();
  let language = savedLanguage;
  if (!language || !supportedLanguages.includes(language)) {
    language = getBrowserLocale(supportedLanguages[0], getSupportedLanguages());
  }
  if (language !== savedLanguage) state.setLanguage(language);
  setLanguage(language);
}
